var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMap = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m13.667 2-.107.02L10 3.4 6 2 2.24 3.267a.336.336 0 0 0-.24.32v10.08a.33.33 0 0 0 .333.333l.107-.02L6 12.6l4 1.4 3.76-1.267a.336.336 0 0 0 .24-.32V2.333A.33.33 0 0 0 13.667 2zM10 12.667 6 11.26V3.333l4 1.407v7.927z"
})));
export default SvgMap;